"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayToIsoDate = arrayToIsoDate;
exports.b64DecodeUnicode = b64DecodeUnicode;
exports.convertFloatToGerman = convertFloatToGerman;
exports.convertGermanToFloat = convertGermanToFloat;
exports.convertThousandsSeparator = convertThousandsSeparator;
exports.default = decodeEntities;
function decodeEntities(givenStr) {
  var str = givenStr;
  // this prevents any overhead from creating the object each time
  var element = document.createElement('div');
  if (str && typeof str === 'string') {
    // strip script/html tags
    str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '');
    str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '');
    element.innerHTML = str;
    str = element.textContent ? element.textContent : '';
    element.textContent = '';
  }
  return str;
}
function b64DecodeUnicode(str) {
  var newStr = str.replace(/\s/g, '');
  return decodeURIComponent(escape(atob(newStr)));
}
function convertThousandsSeparator(amount) {
  var floatPart = amount.split(',')[1];
  var convertedFloatPart = floatPart && floatPart.length === 1 ? "".concat(floatPart, "0") : floatPart;
  var displayFloatPart = floatPart ? convertedFloatPart : '00';
  var displayIntPart = amount ? amount.split(',')[0] : '0';
  if (parseFloat(amount) < 1000) {
    return "".concat(displayIntPart, ",").concat(displayFloatPart);
  }
  var intPart = amount.split(',')[0];
  var intPartLength = intPart.length;
  var convertedIntPart = [];
  var firstPartPosition;
  for (var i = intPartLength - 3; i > 0; i -= 3) {
    var endPosition = i + 3;
    var slicedString = intPart.slice(i, endPosition);
    convertedIntPart.unshift(slicedString);
    firstPartPosition = i;
  }
  var splitStringFirstPart = intPart.slice(0, firstPartPosition);
  convertedIntPart.unshift(splitStringFirstPart);
  return "".concat(convertedIntPart.join('.'), ",").concat(displayFloatPart);
}
function convertFloatToGerman(number) {
  var fractionPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var addSeparator = function addSeparator(part) {
    if (part.length > 3) {
      return "".concat(addSeparator(part.slice(0, -3)), ".").concat(part.slice(-3));
    }
    return part;
  };
  var returnVal;
  if (!number) {
    return 0;
  }
  if (number.toString) {
    returnVal = number.toString();
  }
  var parts = returnVal.split('.');
  var numberOfZeros = '0'.repeat(fractionPlaces);
  var addFracPlaces = function addFracPlaces(frac) {
    return fractionPlaces !== 0 && frac.length < fractionPlaces ? "".concat(frac).concat(numberOfZeros).slice(0, fractionPlaces) : frac;
  };
  var second = parts[1] ? ",".concat(addFracPlaces(parts[1])) : ",".concat(numberOfZeros);
  return "".concat(addSeparator(parts[0])).concat(second);
}
function convertGermanToFloat(number) {
  return parseFloat(number.replace(' ', '').replace('.', '').replace(',', '.'));
}
function arrayToIsoDate(array) {
  var prefix = function prefix(string) {
    return "0".concat(string).slice(-2);
  };
  var year = array[0];
  var month = prefix(array[1]);
  var day = prefix(array[2]);
  return "".concat(year, "-").concat(month, "-").concat(day);
}